/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FullTopListener
 */
export interface FullTopListener {
    /**
     * 
     * @type {Array<FullTopListener>}
     * @memberof FullTopListener
     */
    data?: Array<FullTopListener>;
}

/**
 * Check if a given object implements the FullTopListener interface.
 */
export function instanceOfFullTopListener(value: object): value is FullTopListener {
    let isInstance = true;

    return isInstance;
}

export function FullTopListenerFromJSON(json: any): FullTopListener {
    return FullTopListenerFromJSONTyped(json, false);
}

export function FullTopListenerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FullTopListener {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FullTopListenerFromJSON)),
    };
}

export function FullTopListenerToJSON(value?: FullTopListener | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FullTopListenerToJSON)),
    };
}

